export default "__VITE_ASSET__f0597c91__"